import React, { useState, useMemo } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './menu.css';
import { useSelector } from 'react-redux';
import {
  FileOutlined,
  PieChartOutlined,
  UserOutlined,
  TeamOutlined,
  DollarOutlined,
  BarChartOutlined,
  SettingOutlined,
  SearchOutlined,
  ShopOutlined,
  HomeOutlined,
  CarOutlined,
  RocketOutlined,
  GlobalOutlined,
  BankOutlined,
  CreditCardOutlined,
  EnvironmentOutlined,
  SafetyOutlined,
  ApiOutlined,
  ShoppingCartOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BellOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Image, Breadcrumb, Avatar, Dropdown, Space, Typography, Button } from 'antd';
import HeaderContent from 'components/Header';
import Logo from 'assets/images/logo.png';
import ROUTES from 'config/routes.json';
import { useNavigate, useLocation } from 'react-router';
import Cookies from 'universal-cookie';
import ThemeToggle from 'components/ThemeToggle';
import { useTheme } from 'contexts/ThemeContext';
import ActivitiesIcon from 'assets/search/Activities';
import CarsIcon from 'assets/search/Cars';
import CruisesIcon from 'assets/search/Cruises';
import FlightIcon from 'assets/search/Flight';
import HoteltIcon from 'assets/search/Hotel';
import {ReportIcon} from 'assets/search/Resort';

const { Text } = Typography;
const cookies = new Cookies();

const { Header, Content, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const items = [
  getItem('Dashboard', ROUTES.DASHBOARD, <PieChartOutlined />),
  getItem('Manage Admins', ROUTES.MANAGE_ADMINS, <UserOutlined />),
  getItem('Manage Agencies', '/manage-agencies', <TeamOutlined />, [
    getItem('Agency Reports', ROUTES.MANAGE_AGENCIES, <BarChartOutlined />),
    getItem('Agency Monthly Commission', ROUTES.MANAGE_AGENCIES_COMMISSION, <DollarOutlined />),
  ]),
  getItem('Manage Markups', '/manage-markups', <DollarOutlined />, [
    getItem('Platform Markups', ROUTES.MANAGE_PLATFORM_MARKUPS, <ShopOutlined />),
    getItem('Service Markups', ROUTES.MANAGE_SERVICE_MARKUPS, <ShoppingCartOutlined />),
    getItem('Agency Markups', ROUTES.MANAGE_AGENCY_MARKUPS, <TeamOutlined />),
    getItem('Default Agency', ROUTES.MANAGE_DEFAULT_AGENCY_MARKUPS, <BankOutlined />),
  ]),
  getItem('Reports', '/reports', <BarChartOutlined />, [
    getItem('Hotel Reports', ROUTES.HOTEL_REPORTS, <HoteltIcon />),
    getItem('Car Reports', ROUTES.CAR_REPORTS, <CarsIcon />),
    getItem('Flight Reports', ROUTES.FLIGHT_REPORTS, <FlightIcon />),
    getItem('Activity Reports', ROUTES.ACTIVITY_REPORTS, <ActivitiesIcon />),
    getItem('Cruise Reports', ROUTES.CRUISE_REPORTS, <CruisesIcon />),
    getItem('Resort Reports', ROUTES.RESORT_REPORTS, <ReportIcon />),
    // getItem('Total Reports', ROUTES.TOTAL_REPORTS),
  ]),
  getItem('Settings', '/settings', <SettingOutlined />, [
    getItem('Hotel Radius', ROUTES.HOTEL_RADIUS, <EnvironmentOutlined />),
    getItem('Hotel Vendor', ROUTES.HOTEL_VENDOR, <ShopOutlined />),
    getItem('Payment Gateway', ROUTES.PAYMENT_GATEWAY, <CreditCardOutlined />),
    getItem('Hotel AutoSuggest', ROUTES.HOTEL_AUTOSUGGEST, <SearchOutlined />),
    getItem('Supported Countries', ROUTES.COUNTRY, <GlobalOutlined />),
    getItem('Cruise Lines', ROUTES.CRUISE_LINE, <RocketOutlined />),
    getItem('Locations', ROUTES.LOCATIONS, <EnvironmentOutlined />),
    getItem('OTP Signup Enable', ROUTES.OTP, <SafetyOutlined />),
    getItem('OTP-No Account Created', ROUTES.HIDE_HEADER, <SafetyOutlined />),
    getItem('Extranet', ROUTES.EXTRANET_SETTING, <ApiOutlined />),
    getItem('TripAdd', ROUTES.TRIP_ADD, <ShoppingCartOutlined />),
  ]),
  getItem('Searches', ROUTES.SEARCHES, <SearchOutlined />),
];

const LayoutWrapper = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const userDetails = useSelector((state) => state.user.userDetails);

  const handleChange = ({ key }) => {
    navigation(key);
  };

  const handleLogout = () => {
    ['loginInfo', 'loginTrue', 'isTrue'].forEach((item) => cookies.remove(item, { path: '/' }));
    localStorage.clear();
    cookies.remove('x-access-token', { path: '/' });
    document.location = '/';
  };

  const userMenuItems = [
    // {
    //   key: 'profile',
    //   icon: <UserOutlined />,
    //   label: 'Profile',
    // },
    // {
    //   key: 'settings',
    //   icon: <SettingOutlined />,
    //   label: 'Settings',
    // },
    // {
    //   type: 'divider',
    // },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
      onClick: handleLogout,
    },
  ];

  // Generate breadcrumbs
  const breadcrumbItems = useMemo(() => {
    const path = location.pathname;
    const findPath = (menuItems, currentPath = []) => {
      for (const item of menuItems) {
        if (item.key === path) {
          return [...currentPath, { title: item.label }];
        }
        if (item.children) {
          const found = findPath(item.children, [...currentPath, { title: item.label }]);
          if (found) return found;
        }
      }
      return null;
    };

    const pathItems = findPath(items);
    if (pathItems && pathItems.length > 0) {
      return [{ title: 'Home' }, ...pathItems];
    }
    return [{ title: 'Home' }];
  }, [location.pathname]);

  // Get current selected key from location
  const getSelectedKeys = () => {
    const path = location.pathname;
    // Find matching route - check children first, then parents
    const findRoute = (items) => {
      // First, check all children (submenu items)
      for (const item of items) {
        if (item.children) {
          for (const child of item.children) {
            // Exact match
            if (child.key === path) {
              return [child.key];
            }
            // Path starts with child key (for dynamic routes)
            if (
              path.startsWith(child.key + '/') ||
              (path.startsWith(child.key) && path.length > child.key.length && path[child.key.length] === '/')
            ) {
              return [child.key];
            }
          }
        }
      }
      // Then check parent items
      for (const item of items) {
        // Skip parents that have children (we already checked children)
        if (item.children && item.children.length > 0) {
          continue;
        }
        // Exact match for parent
        if (item.key === path) {
          return [item.key];
        }
        // Path starts with parent key
        if (
          path.startsWith(item.key + '/') ||
          (path.startsWith(item.key) && path.length > item.key.length && path[item.key.length] === '/')
        ) {
          return [item.key];
        }
      }
      return [];
    };
    return findRoute(items) || [];
  };

  const getOpenKeys = () => {
    const path = location.pathname;
    const openKeys = [];
    items.forEach((item) => {
      if (item.children) {
        // Check if any child matches the current path
        const hasMatch = item.children.some((child) => {
          return (
            child.key === path ||
            path.startsWith(child.key + '/') ||
            (path.startsWith(child.key) && path.length > child.key.length && path[child.key.length] === '/')
          );
        });
        if (hasMatch) openKeys.push(item.key);
      }
    });
    return openKeys;
  };

  const { isDark } = useTheme();
  const contentBg = isDark ? '#0a0a0a' : '#f5f7fa';
  const siderBg = isDark ? '#141414' : '#ffffff';
  const headerBg = isDark ? '#141414' : 'rgb(246, 247, 250)';
  const textColor = isDark ? '#ffffff' : '#000000';

  return (
    <Layout className="h-screen" style={{ background: contentBg, transition: 'background-color 0.3s ease' }}>
      <ToastContainer />
      {userDetails && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={256}
          collapsedWidth={80}
          style={{
            background: siderBg,
            boxShadow: isDark ? '2px 0 12px rgba(0, 0, 0, 0.6)' : '2px 0 12px rgba(0, 0, 0, 0.1)',
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            borderRight: isDark ? '1px solid #2d2d2d' : 'none',
            zIndex: 1000,
            transition: 'background-color 0.3s ease, border-color 0.3s ease',
          }}
          theme={isDark ? 'dark' : 'light'}
        >
          <div
            style={{
              padding: collapsed ? '16px' : '20px',
              borderBottom: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: collapsed ? 'center' : 'flex-start',
              minHeight: '72px',
              transition: 'all 0.3s ease',
              background: siderBg,
            }}
          >
            {!collapsed && (
              <Image src={Logo} alt="logo" preview={false} width={120} style={{ transition: 'all 0.2s' }} />
            )}
            {collapsed && (
              <Image
                src={Logo}
                alt="logo"
                preview={false}
                width={50}
                height={50}
                style={{
                  borderRadius: '8px',
                  padding: '4px',
                  background: '#ffffff',
                  boxShadow: '0 2px 8px rgba(255, 107, 53, 0.3)',
                  objectFit: 'contain',
                }}
              />
            )}
          </div>
          <Menu
            theme={isDark ? 'dark' : 'light'}
            selectedKeys={getSelectedKeys()}
            defaultOpenKeys={getOpenKeys()}
            mode="inline"
            items={items}
            onClick={handleChange}
            style={{
              borderRight: 'none',
              padding: '12px 0',
              background: siderBg,
              transition: 'background-color 0.3s ease',
            }}
            className="custom-menu"
          />
        </Sider>
      )}
      <Layout
        style={{
          marginLeft: userDetails ? (collapsed ? 80 : 256) : 0,
          transition: 'margin-left 0.2s',
          minHeight: '100vh',
        }}
      >
        {userDetails && (
          <Header
            style={{
              background: headerBg,
              padding: '0 32px',
              boxShadow: isDark ? '0 2px 8px rgba(0, 0, 0, 0)' : '0 2px 8px rgba(0, 0, 0, 0)',
              position: 'sticky',
              top: 0,
              zIndex: 100,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: 72,
              borderBottom: isDark ? '1px solid #2d2d2d' : '1px solid var(--border-color)',
              transition: 'background-color 0.3s ease, border-color 0.3s ease',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setCollapsed(!collapsed);
                }}
                style={{
                  fontSize: 18,
                  width: 44,
                  height: 44,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '8px',
                  color: textColor,
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = isDark ? '#1a1a1a' : '#f5f5f5';
                  e.currentTarget.style.color = '#ff6b35';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = textColor;
                }}
              />
              <Breadcrumb
                items={breadcrumbItems}
                style={{ marginLeft: 16, color: textColor, transition: 'color 0.3s ease' }}
                separator="/"
              />
            </div>
            <Space size="middle">
              <ThemeToggle />
              {/* <Button
                type="text"
                icon={<BellOutlined />}
                style={{
                  width: 44,
                  height: 44,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '10px',
                  color: textColor,
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = isDark ? '#1a1a1a' : '#f5f5f5';
                  e.currentTarget.style.color = '#ff6b35';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = textColor;
                }}
              /> */}
              <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={['click']}>
                <Space
                  style={{
                    cursor: 'pointer',
                    padding: '6px 16px',
                    borderRadius: '10px',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = isDark ? '#1a1a1a' : '#f5f5f5';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                  }}
                >
                  <Avatar icon={<UserOutlined />} size="small" />
                  <Text strong style={{ color: textColor, transition: 'color 0.3s ease' }}>
                    {userDetails?.name || userDetails?.email || 'User'}
                  </Text>
                </Space>
              </Dropdown>
            </Space>
          </Header>
        )}
        {!userDetails && (
          <Header
            style={{
              background: '#fff',
              padding: '0 24px',
              boxShadow: '0 1px 4px rgba(0, 21, 41, 0.08)',
            }}
          >
            <HeaderContent />
          </Header>
        )}
        <Content
          style={{
            margin: userDetails ? '24px' : 0,
            minHeight: userDetails ? 'calc(100vh - 120px)' : 'calc(100vh - 64px)',
            background: contentBg,
            padding: userDetails ? '32px' : '24px',
            borderRadius: userDetails ? '12px' : 0,
            boxShadow: userDetails && isDark ? '0 0 0 1px rgba(255, 255, 255, 0.05)' : 'none',
            overflowY: 'auto',
            transition: 'background-color 0.3s ease',
            padding: '0 32px',
            margin: '10px 32pxpx 0px 32px',
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};
export default LayoutWrapper;
